import { createContext, useContext, useMemo, type ReactNode, type ReactElement } from "react"
import type {MessageComponentsConfig} from "../types"

interface MessageComponentsContextType {
  config: MessageComponentsConfig
}

const MessageComponentsContext = createContext<MessageComponentsContextType | undefined>(undefined)

interface MessageComponentsProviderProps {
  children: ReactNode
  config: MessageComponentsConfig
}

export function MessageComponentsProvider({ children, config }: MessageComponentsProviderProps): ReactElement {
  const contextValue = useMemo<MessageComponentsContextType>(() => ({ config }), [config])

  return (
    <MessageComponentsContext.Provider value={contextValue}>
      {children}
    </MessageComponentsContext.Provider>
  )
}

export function useMessageComponents(): MessageComponentsContextType {
  const context = useContext(MessageComponentsContext)
  if (context === undefined) {
    throw new Error("useMessageComponents must be used within a MessageComponentsProvider")
  }
  return context
}
